'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-edit.routes';

export class WebaccessEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, WebAccessService, SettingsService, $uibModal, User, ContactService, prompt) {
    'ngInject';

    this.webaccessId = $stateParams.id;

    this.dialogs = dialogs;
    this.WebAccessService = WebAccessService;
    this.SettingsService = SettingsService;
    this.ContactService = ContactService;
    this.$uibModal = $uibModal;
    this.User = User;
    this.Auth = Auth;
    this.prompt = prompt;

    this.jsonValue = "";
    this.users = [];
    this.excludeList = [];
    this.contacts = [];
    this.$state = $state;

    this.selectedSubs = {};

    this.activationType = "invitation";
    this.activationTypes = [{
      type: "initial",
      name: "Initial Password"
    }, {
      type: "invitation",
      name: "Invitation"
    }];

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

      if (this.webaccessId) {

        if (!this.serverSideDT) {
          ContactService.query(data => {
            this.contacts = data.map(contact => {
              contact.value = contact._id;
              contact.name = this.getComposedName(contact);
              return contact;
            });
          });
        }

      } else {

        if (!this.serverSideDT) {

          WebAccessService.query(was => {
            this.excludeList = was
              .filter(wa => wa.contact)   // otherwise removed contacts break the code
              .map(wa => wa.contact._id);

            ContactService.query(data => {
              this.contacts = data
                .filter(contact => !this.excludeList.includes(contact._id))
                .map(contact => {
                  contact.value = contact._id;
                  contact.name = this.getComposedName(contact);
                  return contact;
                });
            });
          })

        }

      }

    });

    this.model = {
      additionalRoles: ["evoting-user"]
    };

    if (this.webaccessId) {
      this.WebAccessService.get({id: this.webaccessId}, data => {
        this.model = data;

        if (this.model.contact && this.serverSideDT) {
          this.ContactService.get({id: this.model.contact}, contact => {
            if (contact) {
              contact.value = contact._id;
              contact.name = this.getComposedName(contact);
              this.contacts.push(contact);
            }
          });
        }
      }, err => {
        console.log('Could not load webaccess from server');
      })
    } else {
      SettingsService.getByName({name: 'config.platform'}, appSettings => {
        this.model.associationOrGroupCode = appSettings.data.clientCode;
        if (appSettings.data.defaultActivationType) {
          this.model.activationType = appSettings.data.defaultActivationType;
        }
      });
    }

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  updateEmail() {
    if (this.model.contact) {
      let oContact = this.contacts.find(o => o._id == this.model.contact);
      if (oContact) {
        let primaryEmail = this.getPrimaryEmail(oContact);
        if (primaryEmail !== '-') {

          if (!this.model.email || (this.model.email == primaryEmail)) {
            this.model.email = primaryEmail;
          } else {

            this.prompt({
              "title": "Replace Email?",
              "message": "The selected contact has another primary email as the one that is currently defined. Do you want to replace the current email?",
              "buttons": [
                {
                  "label": "Cancel",
                  "cancel": true,
                  "primary": false
                },
                {
                  "label": "Yes",
                  "cancel": false,
                  "primary": true
                }
              ]
            }).then(result => {
              this.model.email = primaryEmail;
            });

          }

        }
      }
    }


  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  contactLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: that.serverSideDT ? 'contactLookupSs' : 'contactLookup',
      resolve: {
        config: function() {
          return {
            exclude: that.excludeList
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contact) {

        that.model.contact = contact._id;

        if (that.serverSideDT) {
            contact.value = contact._id;
            contact.name = that.getComposedName(contact);
            that.contacts.push(contact);
        }

        that.updateEmail();
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.webaccessId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The E-Voting Access has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go(that.serverSideDT ? "webaccess-list-ss" : "webaccess-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.email = this.model.email.trim().toLowerCase();

      if (this.webaccessId) {  // Save changes on the current webaccess
        this.WebAccessService.update({id: this.webaccessId  }, this.model, onSuccess, onError);
      } else { // Create new webaccess
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.WebAccessService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.webaccessEdit', [uiRouter])
  .config(routes)
  .component('webaccessEdit', {
    template: require('./webaccess-edit.html'),
    controller: WebaccessEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/edit/webaccess-edit.component.js